import merge from "lodash/merge";
import {
    IChartApi,
    ISeriesApi,
    ISeriesPrimitive,
    ISeriesPrimitiveAxisView,
    IPrimitivePaneView,
    LineStyle,
    SeriesAttachedParameter,
    SeriesOptionsMap,
    Time
} from 'lightweight-charts'
import { darkGrey } from "../../../../assets/colors";
import LabelledVerticalLinePaneView from "./labelledVerticalLine.paneView";
import LabelledVerticalLineAxisLabelView, { LabelledVerticalLineAxisLabelViewOptions } from "./labelledVerticalLine.axisLabelView";

export type LabelledVerticalLineDrawingOptions = {
    price: Time,
    label?: string,
    showLabel?: boolean,
    showAxisLabel?: boolean
    lineType: LineStyle,
    color?: string,
    axisLabelColor?: string,
    axisLabelTextColor?: string,
    opacity?: number,
    width?: number
    lineVisible?: boolean
}

class LabelledVerticalLineDrawing implements ISeriesPrimitive<Time> {
    options: LabelledVerticalLineDrawingOptions
    series: ISeriesApi<any>
    chart: IChartApi;
    paneView: LabelledVerticalLinePaneView;
    axisLabelView: LabelledVerticalLineAxisLabelView;
    xCoordinate: number
    requestUpdate() {
    };

    constructor(options: LabelledVerticalLineDrawingOptions) {
        this.options = merge({
            showLabel: true,
            showAxisLabel: false,
            lineType: LineStyle.Solid,
            color: darkGrey,
            opacity: 1,
            width: 1,
            lineVisible: true
        }, options);
    }
    
    updateXCoordinate() {
        this.xCoordinate = this.chart.timeScale().timeToCoordinate(this.options.price);
    }
    
    attached(param: SeriesAttachedParameter<Time, keyof SeriesOptionsMap>): void {
        const { requestUpdate, chart, series } = param
        this.requestUpdate = requestUpdate
        this.chart = chart;
        this.series = series;
        this.options.showAxisLabel && setTimeout(() => {
            this.updateXCoordinate();
            this.requestUpdate();
        }, 100);
    }
    setOptions(options: Partial<LabelledVerticalLineDrawingOptions>) {
        this.options = merge(this.options, options);
        this.updateXCoordinate();
        this.axisLabelView?.setOptions(this.getLabelOptions());
        this.requestUpdate();
    }

    paneViews(): readonly IPrimitivePaneView[] {
        if (!this.paneView) {
            this.paneView = new LabelledVerticalLinePaneView(this);
        }
        return [this.paneView]
    }

    priceAxisPaneViews(): readonly IPrimitivePaneView[] {
        return [];
    }

    timeAxisPaneViews(): readonly IPrimitivePaneView[] {
        return [];
    }

    priceAxisViews(): readonly ISeriesPrimitiveAxisView[] {
        return [];
    }

    timeAxisViews(): readonly ISeriesPrimitiveAxisView[] {
        if (!this.options.showAxisLabel || !this.xCoordinate) return [];

        if (!this.axisLabelView) {
            this.axisLabelView = new LabelledVerticalLineAxisLabelView(this.getLabelOptions())
        }

        return [this.axisLabelView]
    }

    getLabelOptions(): LabelledVerticalLineAxisLabelViewOptions {
        return {
            xCoordinate: this.xCoordinate,
            labelColor: this.options.axisLabelColor || '#fff',
            textColor: this.options.axisLabelTextColor || 'black',
            text: this.options.label || ''
        }
    }
    destroy() {
        this.paneView?.destroy();
        this.paneView = null;
    }
}

export default LabelledVerticalLineDrawing